import { Layout } from 'antd';
import { NavLink } from 'react-router-dom';

import {
    Calendar03Icon,
    QuestionIcon,
    AiMagicIcon,
    Home04Icon,
    PlayListIcon,
    GlobalEducationIcon
} from 'hugeicons-react';

import Logo from './assets/logo-saha-white.svg';

const { Sider } = Layout;

const Sidebar = () => {
    const deployedAt = process.env.REACT_APP_DEPLOYED_AT || '--/--/---- --:--';

    const menuItems = [
        { to: '/', icon: <Home04Icon />, label: 'Genel Görünüm' },
        { to: '/my-course', icon: <GlobalEducationIcon />, label: 'Kurslarım' },
        { to: '/video-list', icon: <PlayListIcon />, label: 'Videolar' },
        { to: '/ai-assistant', icon: <AiMagicIcon />, label: 'Öğrenme Asistanı' },
        { to: '/reminder', icon: <Calendar03Icon />, label: 'Takvim' },
        { to: '/support', icon: <QuestionIcon />, label: 'Destek' },
    ];

    return (
        <Sider className="sidebar-custom" width={240} breakpoint="lg" collapsedWidth="0">
            <div>
                <div className="logo-container">
                    <NavLink to={"/"}  >
                        <img src={Logo} alt="logo" className="logo" />
                    </NavLink>
                </div>
                <div className="menu-list">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={({ isActive }) =>
                                `menu-link ${isActive ? 'active' : ''}`
                            }
                        >
                            {item.icon}
                            <span className="label">{item.label}</span>
                        </NavLink>
                    ))}
                </div>
            </div>
            <div className="deploy-time">{deployedAt}</div>
        </Sider>
    );
};

export default Sidebar;
